import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import FrameworkContractArticle from "./FrameworkContractArticle";

export default class FrameworkContractArticles extends Component {
    constructor() {
        super();

        this.state = {
            articles: [],
            next_key: 0,
        };

        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    componentWillMount() {
        let articles = window.articles;
        let key = 1;
        for (let item_key in articles) {
            if (articles.hasOwnProperty(item_key)) {
                articles[item_key].key = key;
                key++;
            }
        }
        this.setState({
            articles: articles,
            next_key: key + 1
        });
    }

    addItem() {
        let articles = this.state.articles;
        let key = this.state.next_key;
        articles.push({
            key: key,
            article_title: "",
            article_amount_comma: "",
            article_amount_vat_comma: "",
        });
        key++;
        this.setState({
            articles: articles,
            next_key: key
        });
    }

    removeItem(key) {
        let articles = this.state.articles;
        articles = articles.filter((item) => item.key !== key);
        this.setState({articles});
    }

    render() {
        let articles = this.state.articles;
        let rows = [];
        if (articles.length > 0) {
            for (let item_index in articles) {
                if (articles.hasOwnProperty(item_index)) {
                    let row = articles[item_index];
                    rows.push(
                        <FrameworkContractArticle key={row.key}
                                                  article={row}
                                                  removeFn={this.removeItem}/>
                    );
                }
            }
        } else {
            rows.push(
                <tr key="0">
                    <td colSpan="4">
                        <em dangerouslySetInnerHTML={{__html: window.__js_contracts.no_articles_add_msg}}></em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <Button onClick={this.addItem}
                        bsStyle="primary">
                    <i className="fa fa-plus"></i> {window.__js_contracts.add_article}
                </Button>
                <div className="table-responsive" style={{minHeight: 500}}>
                    <table className="table table-hover table-bordered table-striped">
                        <thead>
                        <tr>
                            <th>{window.__js_contracts.title}*</th>
                            <th>{window.__js_contracts.amount}*</th>
                            <th>{window.__js_contracts.amount_with_vat}*</th>
                            <th>{window.__js_contracts.actions}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

if (document.getElementById("framework-contract-articles")) {
    let element = document.getElementById("framework-contract-articles");
    ReactDOM.render(<FrameworkContractArticles/>, element);
}